import React from "react";
import BuyerInfo from "./BuyerInfo";
import CRUD from "../CRUD/CRUD";
import { getCurrentAccess } from "../../access";
import { editsEverySummitRecord } from "../../access-levels";
import {browserHistory} from "react-router";
import {formatName, formatType, capitalizeAll, addSpaceAfterComma} from "../../utils";
import {dateISOtoUS, dateUStoISO} from "../../date-converter";
import {getData, manageData} from "../../requests/CRUD";
import {BUYERS,HSC_FOLLOW_UP_AGENTS,TEAM} from "../../consts/tables";
import {BUYERS_LIST_COUNT} from "../../consts/queries";
import {sendBuyerEmail} from "../../requests/emailRequests";
import BuyerCompanyInfo from "./BuyerCompanyInfo";
import {priceToString} from "../CRUDProperty/CRUDProperty";
import {url} from "../../consts/env";
import request from 'arcdynamic-request';
import { executeQuery } from "../../requests/executeQuery";

const limit = 1000;

const priceProps = [
    "PRICE_MIN",
    "PRICE_MAX",
];

const dateProps = [
    "LAST_MODIFIED"
];

function convertDataToForm(dbData) {
    const data = {...dbData};

    priceProps
        .filter((key) => data[key])
        .forEach((key) => {
            const num = Number(data[key]);
            if (num === num) {
                // !isNaN
                data[key] = num.toLocaleString();
            }
        });

    dateProps
        .filter(key => data[key])
        .forEach(key => {
            const str = dateISOtoUS(data[key]);
            if (str !== false)
                data[key] = str;
        });

    return data;
}

function convertFormToData(formData) {
    const data = {...formData};

    priceProps.forEach((key) => {
        const num = priceToString(data[key]);
        if (num !== false)
            data[key] = num;
    });

    dateProps
        .filter(key => data[key])
        .forEach(key => {
            const str = dateUStoISO(data[key]);
            if (str !== false)
                data[key] = str;
        });

    return data;
}

export default class CRUDBuyer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            original: null,
            isBusy: null,
            isExists: false,
            users: [],
            error: null,
            success: null,
            errorTabs: [],
            currentTab: 0,
            viewMode: this.props.edit || false,
            previousStatus: null,
            hscAgentsData:[],
            HscFollowUpData:{},
            loggedInUserData:{},
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChangeInput = this.handleChangeInput.bind(this);
        this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
        this.saveData = this.saveData.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.params.id !== nextProps.params.id) {
            this.fetch(nextProps.params.id);
        }
    }

    componentDidMount() {
        this.setState({loggedInUserData: this.props.userData});
        this.fetch(this.props.params.id);
    }

    fetch(id) {
        const loggedInUserData = this.props.userData;
        this.setState({
            data: null,
            error: null,
            success: null,
        });

        getData({
            tableCode:TEAM,
            options:{
                limit: {
                  "count": 1000,
                  "offset": 0
                },
                column: [
                  "ARCIMEDES_ROW_ID",
                  "FIRST_NAME",
                  "LAST_NAME",
                  "DELETED",
                  "IS_AGENT",
                  "EMAIL"
                ],
            }
      }).then((res)=>{
        if(res && res.success && Array.isArray(res.data) && res.data.length){
          const hscAgentsData = res.data.filter(({ EMAIL }) => EMAIL && EMAIL.toLowerCase().includes('highstcapital'));
          this.setState({hscAgentsData})
        }
      })

        if (id === undefined) {
            this.setState({
                data: {},
                original: {}
            });
            return;
        }

        getData({
            tableCode: BUYERS,
            options: {
                filter: [{
                    text: id,
                    code: "ARCIMEDES_ROW_ID",
                    type: "exact",
                }],
            },
        }).then(async res => {
            if (res && res.success && Array.isArray(res.data) && res.data.length) {
                const {ARCIMEDES_ROW_ID} = res.data[0];
                const responseData = {...res.data[0]};
                let HSC_FOLLOW_UP = '';

                const fetchHSCFollowup = await this.getBuyerAssignedHSCAgent(ARCIMEDES_ROW_ID.toString())
                if(Object.keys(fetchHSCFollowup).length && fetchHSCFollowup.AGENT_ID===ARCIMEDES_ROW_ID.toString()) {
                    HSC_FOLLOW_UP = fetchHSCFollowup.HSC_ID ? fetchHSCFollowup.HSC_ID :''
                }

                responseData.HSC_FOLLOW_UP = HSC_FOLLOW_UP;                
                const followUpList = HSC_FOLLOW_UP ? HSC_FOLLOW_UP.split(',') : [];
                responseData['HSC_HOT_LIST'] = followUpList.includes(loggedInUserData.email) ? '1' : '0';
                this.setState({
                    data: convertDataToForm(responseData),
                    original: {...convertDataToForm(responseData)},
                    error: null,
                });
            } else {
                this.setState({
                    data: false,
                    error: res.message ? res.message : "Unidentified Error",
                });
            }
        });
        
    }


    async getBuyerAssignedHSCAgent(buyerId = '') {
        try {
            const res = await getData({
                tableCode: HSC_FOLLOW_UP_AGENTS,
                options: {
                    filter: [{
                        text: buyerId,
                        code: "AGENT_ID",
                        type: "exact",
                    }],
                },
            });
            const result = res && res.data.length && res.data[0];
            this.setState({HscFollowUpData: result})
            return result;
        } catch (error) {
            throw error; 
        }
    }
    

    formatHscMembers(){
        if(Array.isArray(this.state.hscAgentsData) && this.state.hscAgentsData.length){
  
          return this.state.hscAgentsData.map((agent) => {
            return {
              NAME: `${agent.FIRST_NAME} ${agent.LAST_NAME}`,
              HSC_FOLLOW_UP:agent.ARCIMEDES_ROW_ID,
            };
          });
        }  
        return []
    }
    fetchUserData() {
        executeQuery({queryName: BUYERS_LIST_COUNT})
        .then((res)=>{
            let totalRequest = Math.round(res.data[0].TOTAL_COUNT/1000);
            let requests = [];
            let offset = 0;
            for(let i=totalRequest; i>0;i--){
                requests.push(request(arc.path.api, {
                    service: "arcimedes",
                    action: "open.datasource.table.Data.getData",
                    params: [
                        "code",
                        BUYERS,
                        {
                            limit: {
                                count: limit,
                                offset: offset * limit,
                            },
                            column: [
                                'ARCIMEDES_ROW_ID',
								'FIRST_NAME',
								'LAST_NAME',
								'EMAIL',
								'PHONE',
								'DELETED',
                            ],
                            filterType: "and",
                            filter: [
                                {
                                    code: "DELETED",
                                    text: "",
                                    type: "null",
                                },
                            ],
                            order: [
                                {
                                    code: "FIRST_NAME",
                                    type: "asc",
                                },
                                {
                                    code: "LAST_NAME",
                                    type: "asc",
                                },
                            ],
                        },
                    ],
                }));
                ++offset;
            }
        Promise.all(requests).then((res) => {
            if(res){
                var users = []
                res.forEach((resp)=>{
                    if(resp && resp.success){
                        users = [...users, ...resp.data]
                    }
                })
                users = users.filter(user => user.FIRST_NAME !== '' || user.LAST_NAME !== '')
                this.setState({users});
                const isExists = this.state.users.some(user => {
                    if (
                      this.state.data.ARCIMEDES_ROW_ID &&
                      user.ARCIMEDES_ROW_ID === this.state.data.ARCIMEDES_ROW_ID
                    ) {
                      return false;
                    }
                    return (                
                      (user.FIRST_NAME != null && user.FIRST_NAME.toLowerCase()) === (this.state.data.FIRST_NAME != null && this.state.data.FIRST_NAME.toLowerCase()) &&
                      (user.LAST_NAME != null && user.LAST_NAME.toLowerCase()) === (this.state.data.LAST_NAME != null && this.state.data.LAST_NAME.toLowerCase())
                    );
                  });
            
                  this.setState({
                    isExists: !!isExists,
                  });
            
                  if (isExists) {
                    return;
                  } else {
                    this.setState({ viewMode: true }, () => this.saveData());
                  }

            }
          })
        })
    }       
    
    handleSubmit(e) {
        e.preventDefault();

        if (this.state.viewMode) this.setState({viewMode: false});         
        if  (!this.state.data.FIRST_NAME || !this.state.data.LAST_NAME) {
            this.setState({errorTabs: [0], success: null});
            return;
        } else {
            if (this.state.isBusy || this.state.viewMode === true) return;
            this.setState({errorTabs: []});
            this.fetchUserData();
        }
    }
    /* handleChangeInput(key, value) {
        this.setState({
            data: Object.assign(this.state.data, {[key]: value}),
        });
    } */

    handleChangeInput (key, value)  {
        this.setState((prevState) => {
            let newValue;

            if (key === "HSC_HOT_LIST") {
                newValue = prevState.data[key] === "1" ? "0" : "1"; // Toggle between "1" and "0"
            } else {
                newValue = value;
            }

            return {
                data: {
                    ...prevState.data,
                    [key]: newValue,
                    
                }
            };
        }); 
    }
    handleChangeDropdown(query, queryType, x, key) {
        const data = {...this.state.data};
        if (key === 'STATUS') {
            data.LAST_MODIFIED = new Date().toLocaleDateString("en-US");
            if (!query[key]) {
                data.CATEGORY = null;
                data.TYPE = null;
                data.SINGLE_TENANT_SUBCATEGORY = null;
                data.MULTI_TENANT_SUBCATEGORY = null;
                data.MARKET = null;
                data.PRICE_MIN = null;
                data.PRICE_MAX = null;
                data.CAP_RATE_MIN = null;
                data.CAP_RATE_MAX = null;
                data.STRIVE_AGENT = null;
            }
        }
        data[key] = query[key];
        this.setState({data});
    }

    saveData() {
        //const loggedInUserId = this.state.loggedInUserData.id;
        const loggedInUserEmail = this.state.loggedInUserData.email;
        if (this.state.isBusy) return;

        this.setState({
            isBusy: true,
            error: null,
            success: null,
        });

        Object.keys(this.state.data).forEach((k) => {
            if (!this.state.data[k] || k === "undefined") {
                const newData = {...this.state.data};
                delete newData[k];
                this.setState({data: newData});
            }
        });
        
        let formattedState = {...this.state.data}
        let hotlist;
        if (formattedState["HSC_HOT_LIST"] === "1") {         
             if (formattedState["HSC_FOLLOW_UP"]) {
                const followUpList = formattedState["HSC_FOLLOW_UP"].split(",");
                if (!followUpList.includes(loggedInUserEmail)) {
                    followUpList.push(loggedInUserEmail);
                }
                hotlist = followUpList.join(",");
            } else {
                hotlist = loggedInUserEmail;
            } 
        } else if (formattedState["HSC_HOT_LIST"] === "0") {
            if (formattedState["HSC_FOLLOW_UP"]) {
                let followUpList = formattedState["HSC_FOLLOW_UP"]
                                    .split(",")
                                    .map(email => email.trim())
                                    .filter(email => email !== loggedInUserEmail);

                //let followUpList = formattedState["HSC_FOLLOW_UP"].split(",");
                //followUpList = followUpList.filter(email => email !== loggedInUserEmail); 
                hotlist = followUpList.length > 0 ? followUpList.join(",") : ""; 
            }
        }
		delete formattedState.HSC_FOLLOW_UP
        delete formattedState.HSC_HOT_LIST
        
        Promise.all([
            manageData({
                tableCode: BUYERS,
                data: [convertFormToData(formattedState)],
            }),
            getData({
                tableCode: "TEAM",
                options: {
                    column: ["FIRST_NAME", "LAST_NAME"],
                    filter: [{
                        text: this.state.data.STRIVE_AGENT ? this.state.data.STRIVE_AGENT.toString() : "",
                        code: "ARCIMEDES_ROW_ID",
                        type: "exact",
                    }],
                },
            }),            
        ]).then((res) => {
            let previousStatus;
            if (res && res[0] && res[0].success && res[1] && res[1].success) {
                previousStatus = this.state.original.STATUS;
                
                
                this.setState({
                    isBusy: false,
                    success: "Saved",
                    original: res[0].data[0],
                }, () => {
                    if (!this.props.edit) {
                        browserHistory.push({
                            pathname: `/buyer/${res[0].data[0].ARCIMEDES_ROW_ID}`,
                        });
                    }}
                );              
                manageData({
                    tableCode: HSC_FOLLOW_UP_AGENTS,
                    data: [{
                        ...this.state.HscFollowUpData,
                        AGENT_ID: res[0].data[0].ARCIMEDES_ROW_ID,
                        HSC_ID: hotlist//this.state.data.HSC_FOLLOW_UP,
                    }],
                }).then(()=>{
                    browserHistory.push({pathname: `/buyer/${res[0].data[0].ARCIMEDES_ROW_ID}`});
                })
                window.scrollTo(0, 0);
            } else {
                this.setState({
                    isBusy: null,
                    data: null,
                    original: null,
                    error: res && res[0] && res[0].message ? res[0].message : "Unspecified error",
                });
            }
            return {
                success: res[0].success && res[1].success,
                previousStatus,
                STATUS: res[0].data[0] && res[0].data[0].STATUS,
                CATEGORY: capitalizeAll(res[0].data[0] && res[0].data[0].CATEGORY),
                TYPE: formatType(res[0].data[0] && res[0].data[0].TYPE),
                MARKET: capitalizeAll(res[0].data[0] && res[0].data[0].MARKET),
                TENANT_SUBCATEGORY: res[0].data[0] && res[0].data[0].TYPE === "MT" ? addSpaceAfterComma(res[0].data[0] && res[0].data[0].MULTI_TENANT_SUBCATEGORY) : res[0].data[0] && res[0].data[0].TYPE === "STNL" ? addSpaceAfterComma(res[0].data[0] && res[0].data[0].SINGLE_TENANT_SUBCATEGORY) : null,
                PRICE_MIN: res[0].data[0]&&res[0].data[0].PRICE_MIN,
                PRICE_MAX: res[0].data[0]&&res[0].data[0].PRICE_MAX,
                CAP_RATE_MIN: res[0].data[0]&&res[0].data[0].CAP_RATE_MIN,
                CAP_RATE_MAX: res[0].data[0]&&res[0].data[0].CAP_RATE_MAX,
                NOTES: res[0].data[0]&&res[0].data[0].NOTES,
                STRIVE_AGENT: res[1].data.length ? formatName(res[1].data[0]) : null,
                LINK: `${url}investors?FIRST_NAME=${res[0].data[0]&&res[0].data[0].FIRST_NAME}&LAST_NAME=${res[0].data[0]&&res[0].data[0].LAST_NAME}`
            };
        }).then((res) => {
            if (res.success && res.STATUS === '1031-Buyer')
                sendBuyerEmail(res);
            if (res.success && !res.previousStatus && res.STATUS === 'Active')
                sendBuyerEmail(res);
        });
    }

    render() {
        const data = this.state.data;
        const { edit } = this.props;

        return (
            <CRUD
                tabsData={[
                    {
                        name: "Investor",
                        renderedComponent: (
                            <BuyerInfo
                                isExists={this.state.isExists}
                                data={data}
                                handleChangeInput={this.handleChangeInput}
                                handleChangeDropdown={this.handleChangeDropdown}
                                viewMode={this.state.viewMode}
                                deleted={data && data.DELETED === "1"}
                                hscAgentsData ={this.state.hscAgentsData}
                                hscOptions ={this.formatHscMembers()}
                            />
                        ),
                    },
                    {
                        name: "Investor Company",
                        renderedComponent: (
                            <BuyerCompanyInfo
                                data={data}
                                handleChangeInput={this.handleChangeInput}
                                handleChangeDropdown={this.handleChangeDropdown}
                                viewMode={this.state.viewMode}
                                deleted={data && data.DELETED === "1"}
                            />
                        ),
                    },
                ]}
                backLink={`${arc.path.base}investors`}
                edit={edit}
                state={this.state}
                setState={this.setState.bind(this)}
                handleSubmit={this.handleSubmit}
                saveData={this.saveData}
                type="buyer"
                backName="BUYERS"
                title={data && `${data.FIRST_NAME} ${data.LAST_NAME}`}
                /* Edit and Delete for whoever edits every SUMMIT record (the old admin rule). */
                forceActions={editsEverySummitRecord(getCurrentAccess())}
            />
        );
    }
}
